import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-news-analysis',
  templateUrl: './news-analysis.component.html',
  styleUrls: ['./news-analysis.component.scss']
})
export class NewsAnalysisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
